<template>
  <OButton
    size="lg"
    primary
    icon="svguse:#icon_sliders"
    icon-size="1.25rem"
    class="sm:w-full"
    label="Filtros"
  >
    <q-menu
      ref="popup"
      class="overflow-x-hidden w-[25rem] sm:w-[22rem] border border-neutral-100/10 shadow-xl"
      anchor="bottom right"
      self="top right"
      :offset="[0, 6]"
    >
      <q-list class="p-24 flex flex-col gap-24 sm:p-16 sm:gap-16">
        <div class="space-y-8">
          <div
            class="py-10 px-14 space-y-8 border border-neutral-100/10 rounded-md"
          >
            <p class="w-max text-paragraph-4 text-neutral-70">Tier</p>
            <div class="flex gap-16">
              <ORadio
                v-if="tierList.find((tier) => tier.fab_tier === 1)"
                v-model="model.tier"
                label="MMUC"
                :val="1"
                size="md"
              />

              <ORadio
                v-if="tierList.find((tier) => tier.fab_tier === 2)"
                v-model="model.tier"
                label="W/O SOV"
                :val="2"
                size="md"
              />
            </div>
          </div>

          <div
            v-if="model.tier === 1"
            class="py-10 px-14 space-y-8 border border-neutral-100/10 rounded-md"
          >
            <p class="w-max text-paragraph-4 text-neutral-70">
              Cluster
            </p>
            <div class="flex gap-16">
              <q-checkbox
                v-if="tierList.find((tier) => tier.fab_tier_type === 'A')"
                v-model="model.type_a"
                label="> 150"
                dense
              />
              <q-checkbox
                v-if="tierList.find((tier) => tier.fab_tier_type === 'B')"
                v-model="model.type_b"
                label="<= 150"
                dense
              />
            </div>
          </div>
        </div>

        <label class="flex flex-col">
          <p class="w-max text-paragraph-4 text-neutral-70">Zona</p>

          <OSelectPaginated
            placeholder="Todas"
            clearable
            :model-value="model.zona"
            :update-on-focus="true"
            :adictional-filters="{ fab_tier: model.tier, t: 'global' }"
            api-url="copa/api/filters/zones/"
            option-label="fab_zone"
            option-value="fab_zone"
            class="bg-white"
            @update:model-value="model.zona = $event"
          />
        </label>

        <label class="flex flex-col">
          <p class="w-max text-paragraph-4 text-neutral-70">
            Fabricantes
          </p>

          <OSelectPaginated
            placeholder="Todos"
            clearable
            :model-value="model.fabricante"
            :update-on-focus="true"
            :adictional-filters="{
              fab_tier: model.tier,
              fab_tier_type: filterParams.fab_tier_type,
              fab_zone: model.zona?.fab_zone,
              t: 'global'
            }"
            api-url="copa/api/filters/bottlers/"
            option-label="fab_name"
            option-value="fab_code"
            class="bg-white"
            @update:model-value="model.fabricante = $event"
          />
        </label>

        <div
          class="flex items-center justify-end gap-16 sm:grid sm:grid-cols-2 sm:gap-8"
        >
          <OButton
            size="md"
            class="sm:w-full"
            tertiary
            @click="cleanFields"
          >
            Limpar
          </OButton>
          <OButton
            size="md"
            class="sm:w-full"
            primary
            @click="handleClickFilter"
          >
            Consultar
          </OButton>
        </div>
      </q-list>
    </q-menu>
  </OButton>
</template>

<script setup>
import { ref, watch } from 'vue'
import OButton from 'components/Button/OButton.vue'
import ORadio from 'components/Radio/ORadio.vue'
import OSelectPaginated from 'components/Select/OSelectPaginated.vue'
import {
  tierList,
  filterModel,
  filterParams,
  shouldRemoveDynamicColumns,
  quickWinsHighlightsData,
} from 'store/copa.stores'

const emit = defineEmits(['filter-applied'])

const popup = ref(null)

const model = filterModel

// Reset type_a, type_b e coluna dinâmica quando tier mudar
watch(
  () => model.value.tier,
  () => {
    model.value.type_a = false
    model.value.type_b = false

    // Sinalizar remoção de colunas dinâmicas
    shouldRemoveDynamicColumns.value = true
  }
)

// Reset zona e fabricante quando tier, type_a ou type_b mudarem
watch(
  () => [model.value.tier, model.value.type_a, model.value.type_b],
  () => {
    model.value.zona = ''
    model.value.fabricante = ''
  }
)

// Reset fabricante quando zona mudar
watch(
  () => model.value.zona,
  () => (model.value.fabricante = '')
)

const handleClickFilter = () => {
  quickWinsHighlightsData.value = []
  emit('filter-applied')
  popup.value.hide()
}

const cleanFields = () => {
  model.value = {
    tier: 1,
    type_a: false,
    type_b: false,
    zona: '',
    fabricante: '',
  }
}

defineExpose({
  filterParams,
})
</script>
